import React, { useState, useEffect } from 'react';
import apiService from '../api/apiService';
import './TablePages.css';

interface LiterRow {
  id: number;
  size: number;
  is_active: boolean;
}

const Liters: React.FC = () => {
  const [list, setList] = useState<LiterRow[]>([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [formSize, setFormSize] = useState('');
  const [formActive, setFormActive] = useState(true);
  const [editingId, setEditingId] = useState<number | null>(null);

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await apiService.get('/admin/liters');
      setList(data);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const openAdd = () => {
    setEditingId(null);
    setFormSize('');
    setFormActive(true);
    setShowForm(true);
  };

  const openEdit = (row: LiterRow) => {
    setEditingId(row.id);
    setFormSize(String(row.size));
    setFormActive(row.is_active);
    setShowForm(true);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const size = parseFloat(formSize);
    if (Number.isNaN(size) || size <= 0) {
      alert('Enter a valid size (e.g. 14, 19).');
      return;
    }
    try {
      if (editingId) {
        await apiService.put(`/admin/liters/${editingId}`, { size, is_active: formActive });
      } else {
        await apiService.post('/admin/liters', { size, is_active: formActive });
      }
      setShowForm(false);
      load();
    } catch (err: any) {
      alert(err.response?.data?.detail || 'Failed');
    }
  };

  const handleDelete = async (id: number) => {
    if (!window.confirm('Delete this liter size?')) return;
    try {
      await apiService.delete(`/admin/liters/${id}`);
      load();
    } catch (err: any) {
      alert(err.response?.data?.detail || 'Failed');
    }
  };

  return (
    <div className="table-page">
      <div className="table-toolbar">
        <div className="table-toolbar-right">
          <button type="button" className="btn-primary" onClick={openAdd}>Add size</button>
          <button type="button" onClick={load} className="btn-primary">Refresh</button>
        </div>
      </div>
      {loading ? (
        <p>Loading...</p>
      ) : (
        <div className="table-wrapper">
          <table className="data-table">
            <thead>
              <tr>
                <th>Size (L)</th>
                <th>Active</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {list.map((row) => (
                <tr key={row.id}>
                  <td>{row.size}L</td>
                  <td>{row.is_active ? 'Yes' : 'No'}</td>
                  <td>
                    <div className="table-actions">
                      <button type="button" className="btn-sm" onClick={() => openEdit(row)}>Edit</button>
                      <button type="button" className="btn-sm red" onClick={() => handleDelete(row.id)}>Delete</button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {showForm && (
        <div className="modal-overlay" onClick={() => setShowForm(false)}>
          <div className="modal-card" onClick={(e) => e.stopPropagation()}>
            <h3>{editingId ? 'Edit' : 'Add'} liter size</h3>
            <form onSubmit={handleSubmit}>
              <label>Size (liters)</label>
              <input
                type="number"
                step="0.1"
                min="0.1"
                value={formSize}
                onChange={(e) => setFormSize(e.target.value)}
                className="input-field"
                required
              />
              <label>
                <input type="checkbox" checked={formActive} onChange={(e) => setFormActive(e.target.checked)} />
                Active
              </label>
              <div className="form-actions">
                <button type="button" className="btn-secondary" onClick={() => setShowForm(false)}>Cancel</button>
                <button type="submit" className="btn-primary">Save</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Liters;
